<template>
    <div>
        <b-row>
            <b-col>
                <label for="roles">Roles</label>
                <b-row>
                    <b-col>
                        <b-btn @click="selectAll(true)" variant="link">Todos</b-btn>
                        &nbsp;|&nbsp;
                        <b-btn @click="selectAll(false)" variant="link">Ninguno</b-btn>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" md="3" v-for="role in roles" :key="role.id">
                        <b-form-checkbox v-model="selectedRoles" :value="role.id">
                            {{ role.name }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row align-h="end">
                    <b-col cols="auto">
                        <b-btn variant="primary" @click="sendToRoles"><i class="fas fa-paper-plane"></i> Enviar a roles</b-btn>
                    </b-col>
                </b-row>
                <!-- <b-row align-h="end">
                    <b-col cols="auto">
                        <b-btn size="sm" variant="primary" @click="loadPeople">Enviar Invitaciones</b-btn>
                    </b-col>
                </b-row> -->
            </b-col>
        </b-row>
        <b-row class="my-5">
            <b-col>
                <app-form-input label="Buscar Personas" @keyup.enter="search" v-model="term"></app-form-input>
            </b-col>
        </b-row>
        <b-row v-if="!!people.length" class="mb-5">
            <b-col>
                <b-list-group>
                    <b-list-group-item v-for="person in people" :key="person.id" class="d-flex justify-content-between align-items-center">
                        <div>
                            {{ person.name }} (<span class="text-info">{{ person.email }}</span
                            >) - {{ person.structures.pluck('name').join(', ') }}
                        </div>
                        <div>
                            <b-btn size="sm" :disabled="busy" variant="primary" @click="sendInvitation(person)"><i class="fas fa-paper-plane"></i></b-btn>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
const Clusterize = require('clusterize.js')
export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        roles: [],
        selectedRoles: [],
        selectedPeople: [],
        people: [],
        fields,
        clusterize: null,
        term: '',
        busy: false,
    }),
    computed: {},
    methods: {
        async loadRoles() {
            const { data: roles } = await this.$repo.get('roles', { sortBy: 'name' })
            this.roles = roles
        },
        async sendToRoles() {
            if (this.selectedRoles.length === 0) return toastr.warning('Debe seleccionar por lo menos un rol para enviar las invitaciones al evento')
            try {
                const { data } = await this.$repo.post(`events/${this.event.id}/send-to-roles`, { roles: this.selectedRoles.join(',') })
                toastr.success('Las invitaciones se estan enviando satisfactoriamente')
            } catch (error) {
                toastr.error('Ocurrió un error al enviar las invitaciones, por favor intente de nuevo más tarde')
            }
        },
        async search() {
            const { data: people } = await this.$repo.get('people', {
                venueId: this.currentVenue.id,
                term: this.term,
            })
            this.people = people
        },
        async loadPeople() {
            const { data: people } = await this.$repo.get('people', {
                venueId: this.currentVenue.id,
                roles: this.selectedRoles,
            })
            this.people = people
        },
        selectAll(val) {
            this.selectedRoles = !!val ? this.roles.map((item) => item.id) : []
        },
        async sendInvitation(person) {
            try {
                this.busy = true
                const { data } = await this.$repo.post(`events/${this.event.id}/send-invitation`, {
                    personId: person.id,
                })
                toastr.success('Invitación enviada satisfactoriamente')
            } catch (error) {
                toastr.error('Ocurrió un error enviando la invitación, por favor intente de nuevo más tarde')
            } finally {
                this.busy = false
            }
        },
    },
    mounted() {
        this.loadRoles()
    },
}

const fields = [
    {
        key: 'name',
        label: 'Nombre',
    },
    {
        key: 'email',
        label: 'E-mail',
    },
    {
        key: 'structures',
        label: 'Unidades',
    },
    {
        key: 'actions',
        label: 'Seleccionar',
    },
]
</script>

<style></style>
